<div mat-dialog-content class="flex">
    <iframe #iframe [src]="url"></iframe>
</div>